// What the reset and invite pages show after success (FR-039, FR-044; data-model §9): chosen only
// from the `allowedClients` the server returns, never guessed.
import type { Api } from "@/api/types";

import { AUTH_COPY } from "../copy";

export type InviteOutcome =
  "APP_LOG_IN" | "ADMIN_CONSOLE" | "DRIVER_APP" | "NO_ACCESS";

export function inviteOutcome(
  allowedClients: readonly Api["Client"][],
): InviteOutcome {
  if (allowedClients.includes("app")) return "APP_LOG_IN";
  if (allowedClients.includes("admin")) return "ADMIN_CONSOLE";
  if (allowedClients.includes("driver")) return "DRIVER_APP";
  return "NO_ACCESS";
}

export type OutcomeView = {
  text: string;
  /** Only an account that can use this app gets Log in (FR-044: no route in for drivers). */
  showLogIn: boolean;
};

export function outcomeView(
  outcome: InviteOutcome,
  page: "reset" | "invite",
): OutcomeView {
  const copy = page === "reset" ? AUTH_COPY.reset : AUTH_COPY.invite;
  switch (outcome) {
    case "APP_LOG_IN":
      return { text: copy.doneApp, showLogIn: true };
    case "ADMIN_CONSOLE":
      return { text: copy.doneAdmin, showLogIn: false };
    case "DRIVER_APP":
      return { text: copy.doneDriver, showLogIn: false };
    case "NO_ACCESS":
      return { text: AUTH_COPY.refusals.noAccess, showLogIn: false };
  }
}
